import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AvatalistPage } from './avatalist';

@NgModule({
  declarations: [
    AvatalistPage,
  ],
  imports: [
    IonicPageModule.forChild(AvatalistPage),
  ],
})
export class AvatalistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/avatalist/avatalist.module.ts